import script from "./CancelOrderTips.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancelOrderTips.vue?vue&type=script&setup=true&lang=ts"

import "./CancelOrderTips.vue?vue&type=style&index=0&id=e4577adc&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4577adc"]])

export default __exports__